<template>
  <public-page :skip-auth-redirect="true">
    <v-row align="center" justify="center" class="fill-height">
      <v-col cols="6" lg="6" md="6" sm="12">
        <v-card v-if="ready" elevation="4">
          <v-alert title="Account Verification" :type="type"
            >{{ text }}

            <v-card-actions v-if="type == 'error'">
              <v-btn
                block
                text
                @click="$router.push({ name: 'ActivationEmail' }, () => {})"
                >Request new token</v-btn
              >
            </v-card-actions>
          </v-alert>
        </v-card>
      </v-col>
    </v-row>
  </public-page>
</template>

<script>
import { API } from "@/axios-config";
import PublicPage from "@/components/PublicPage";

export default {
  name: "ActivateAccount",
  data() {
    return {
      ready: false,
      type: "success",
      text: "",
      code: "",
      valid: true,
    };
  },
  components: {
    PublicPage,
  },
  methods: {
    async activateAccount() {
      var token = this.$route.params.token;
      console.log(token);
      try {
        await API.get(`api/v1/accounts/verify/${token}/`);
        this.type = "success";
        this.text =
          "Your account is verified. You will get an email when your account is approved.";
      } catch (error) {
        if (error.response.status == 400) {
          if (error.response.data.code == "already_verified") {
            this.type = "info";
            this.text =
              "Your account is already verified. You will get an email when your account is approved.";
          } else if (error.response.data.code == "invalid_token") {
            this.type = "error";
            this.text = "The token is invalid or expired";
          } else {
            this.type = "error";
            this.text = "Unknown error";
          }
        } else {
          this.type = "error";
          this.text = "Unknown error";
        }
        console.log(error);
      }
      this.ready = true;
    },
  },
  mounted() {
    this.activateAccount();
  },
};
</script>

<style scoped>
.v-btn,
.v-card {
  border-radius: 4px;
}
.v-card__title {
  text-transform: uppercase;
}
</style>